<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="exams"
    :items-per-page="10"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :footer-props="{ 'items-per-page-text': 'Số kỳ kiểm tra mỗi trang' }"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Kỳ kiểm tra thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} kỳ kiểm tra
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <a :href="`/exams/${item.id}`" class="clickable-text">
        {{ item.name }}
      </a>
    </template>
    <template v-slot:[`item.grade`]="{ item }"> Khối {{ item.grade === 'secondary' ? '6' : '10' }} </template>
    <template v-slot:[`item.status`]="{ item }">
      {{ item | getStatus }}
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item | getType }}
    </template>
    <template v-slot:[`item.startDate`]="{ item }">
      {{ item.startDate | getDate }}
    </template>
    <template v-slot:[`item.reviewDate`]="{ item }">
      {{ item.reviewDate | getDate }}
    </template>
    <template v-slot:[`item.reviewReturnDate`]="{ item }">
      {{ item.reviewReturnDate | getDate }}
    </template>
  </v-data-table>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
const originHeaders = [
  {
    text: 'Tên kỳ kiểm tra',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Loại kiểm tra',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },

  {
    text: 'Ngày kiểm tra',
    value: 'startDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Hạn phúc khảo',
    value: 'reviewDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Hạn trả phúc khảo',
    value: 'reviewReturnDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Địa điểm',
    value: 'location',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  }
]

export default {
  props: {
    exams: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {
    this.loading = true
  },
  watch: {
    exams(newVal) {
      if (newVal) {
        this.loading = false
      }
    }
  },
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    },
    getType: item => {
      switch (item.type) {
        case 'midTerm':
          return 'Kiểm tra giữa kỳ'
        case 'final':
          return 'Kiểm tra cuối kỳ'
        case 'extra':
          return 'Kiểm tra khác'
        default:
          return ''
      }
    },
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return 'Chưa có thông tin'
    }
  }
}
</script>
